import { render, staticRenderFns } from "./UserPreferencesPage.vue?vue&type=template&id=47636368&scoped=true&"
import script from "./UserPreferencesPage.vue?vue&type=script&lang=js&"
export * from "./UserPreferencesPage.vue?vue&type=script&lang=js&"
import style0 from "./UserPreferencesPage.vue?vue&type=style&index=0&id=47636368&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47636368",
  null
  
)

export default component.exports